import { Actions, Effect, ofType } from '@ngrx/effects';
import {
  AssignmentsActionTypes,
  LoadAssignments,
  LoadAssignmentsFail,
  LoadAssignmentsSuccess,
  AssignUsers,
  AssignUsersFail,
  AssignUsersSuccess
} from './actions';
import { of, Observable } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AssignmentsService } from '../../services/assignments.service';

@Injectable()
export class AssignmentsEffects {
  @Effect()
  public fetchAssignments$: Observable<
    LoadAssignmentsSuccess | LoadAssignmentsFail
  > = this.actions$.pipe(
    ofType(AssignmentsActionTypes.Load),
    switchMap((action: LoadAssignments) =>
      this.assignmentsService.getAssignments(action.payload).pipe(
        map(userIds => new LoadAssignmentsSuccess(userIds)),
        catchError(err => of(new LoadAssignmentsFail(err)))
      )
    )
  );

  @Effect()
  public assignUsers$: Observable<
    AssignUsersSuccess | AssignUsersFail
  > = this.actions$.pipe(
    ofType(AssignmentsActionTypes.AssignUsers),
    switchMap(({ payload: { dealId, userIds } }: AssignUsers) =>
      this.assignmentsService.assignUsers(dealId, userIds).pipe(
        map(() => new AssignUsersSuccess({ dealId, userIds })),
        catchError(err => of(new AssignUsersFail(err)))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private assignmentsService: AssignmentsService
  ) {}
}
